import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";
import "./AdminLogin.scss";
import { use } from "react";
import logo from "../src/assets/logo.webp";
import whatsapp from "../src/assets/img/whatsapp.png";
import whatsappicon from "../src/assets/img/whatsappicon.gif";
import image2 from "../src/assets/img/image2.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function Login() {
  const [mobileNumber, setMobileNumber] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const storedToken = localStorage.getItem("userToken");
  const [DatamarkUnseensettings, setDatamarkUnseensettings] = useState(null);
  const isAdmin = localStorage.getItem("isAdmin");
  const [logoimage, setLogoImage] = useState(null);
  
  useEffect(() => {
    if(storedToken){
      navigate("/HomePage");
    }
    if (isAdmin === "false") {
      navigate("/HomePage");
    }
  }, [isAdmin, navigate]);

  useEffect(() => {
    markUnseensettings();
  }, []);

  const markUnseensettings = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL_NODE}admin/settings`,
        {
          method: "GET",
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const result = await response.json();
      setDatamarkUnseensettings(result);

      if (Array.isArray(result) && result.length > 0) {
        setLogoImage(result[0].logo);
      } else if (result.logo) {
        setLogoImage(result.logo);
      }
      console.log("Fetched Data:", result);
    } catch (error) {
      console.error("Error marking messages as seen:", error);
    }
  };

  const handleLogin = async () => {
    if (!userName  || !password) {
      Swal.fire({
        title: "Missing Fields",
        text: "Please enter all required details.",
        icon: "warning",
        confirmButtonText: "Okay"
      });
      return;
    }

    setLoading(true);
    setError("");

    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}user-login`, {
        
        mobileNumber,
        userName,
        password,
      });
      console.log("loginnnnnnn", res.data);
      if (res.data.status === 1) {
        localStorage.setItem("userid", res.data.user.userId);
        localStorage.setItem("userToken", res.data.token);
        localStorage.setItem("isAdmin", res.data.user.isAdmin);

        Swal.fire({
          title: "Login Successful!",
          text: "You are now logged in.",
          icon: "success",
          confirmButtonText: "Proceed"
        }).then(() => {
          navigate("/HomePage");
        });
      } else {
        Swal.fire({
          title: "Login Failed",
          text: res.data.message || "Invalid credentials.",
          icon: "error",
          confirmButtonText: "Try Again"
        });
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Login failed. Please try again.";
      setError(errorMessage);
      Swal.fire({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "Okay"
      });
    } finally {
      setLoading(false);
    }
  };



  const handleVerifyOtp = async () => {
    if (!otp) {
      setError("Please enter the OTP.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      const res = await axios.post(`https://sara777chatapi.sindoor7.com/user/verify-otp`, { mobileNumber, otp });
      if (res.data.status === 1) {

        localStorage.setItem("userid", res.data.user.id);
        localStorage.setItem("userToken", res.data.token);
        localStorage.setItem("isAdmin", res.data.user.isAdmin);
        Swal.fire({
          title: "Login Successful!",
          text: "You are now logged in.",
          icon: "success",
          confirmButtonText: "Proceed"
        }).then(() => {
          navigate("/HomePage"); // Redirect after closing alert

        });
      } else {
        setError("Invalid OTP. Please try again.");
        Swal.fire({
          title: "Login Failed",
          text: "Invalid OTP. Please try again.",
          icon: "error",
          confirmButtonText: "Try Again"
        });
      }
    } catch (error) {
      console.log(error);
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <section className="login_area py-5">
        <div className="container">
          <div className="row align-items-center g-4">

            <div className="col-xl-6 offset-xl-3">
              <div className="hfive_card p-6 p-sm-9 rounded-3">
                <div className="d-flex justify-content-center">
                  {/*  <a
                      href={`https://wa.me/+91${DatamarkUnseensettings && DatamarkUnseensettings.whatsapp_no
                        }?text=`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className=""
                    >
                  <div className="position-relative whatsappicon_design">
                     <img src={whatsappicon} alt="whatsappicon"/>
                     <span className="get_newid blink">Contact On Whatsapp
                       <small>Get new ID</small>
                     </span>
                  </div> 
                  </a>*/}
                  {DatamarkUnseensettings?.whatsapp_no && (
                    <React.Fragment>
                      <a href={`https://wa.me/+91${DatamarkUnseensettings.whatsapp_no}?text=Hello`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className=""
                      //  class="btn-whatsapp-pulse"
                      >
                        {/* <i class="bi bi-whatsapp"></i> */}
                        <div className="whatsappicon">
                          <div className="image_new ">
                            <img className="whatsapp-img img1" src={whatsappicon} alt="WhatsApp" />
                          </div>
                          {/* <div className="image_new img2">

                        <img className="whatsapp-img " src={image2} alt="WhatsApp" />
                        </div> */}

                        </div>
                      </a>
                      {/* <span className="newiddesign">
                        New ID? <small>WhatsApp us!</small>
                      </span> */}
                    </React.Fragment>
                  )}
                  {/* <div className="d-flex justify-content-center whatsappsend">
                {DatamarkUnseensettings?.whatsapp_no && (
                  <a
                    href={`https://wa.me/+91${DatamarkUnseensettings.whatsapp_no}?text=Hello`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="whatsapp-button"
                  >
                    <div className="animated-border text-lg font-semibold rounded-lg shadow-md hover:scale-105 transition">
                      <div className="whatsappicon">
                        <img height={40} width={40} src={whatsapp} alt="WhatsApp" />
                      </div>
                     
                    </div>
                  </a>
                )}
              </div> */}

                </div>
                {/* <a

                  className="navbar-brand d-block mb-4 text-decoration-none text-center"
                >
                  {logoimage ? (
                    <img
                      className="img-fluid logo-color mt-3"
                      src={`https://api.Cash365days.in/uploads/${logoimage}`}
                      alt="Brand logo"
                      width={200}
                      height={200}
                    />
                  ) : (
                    <img src={logo}
                      className="img-fluid logo-color mt-3"
                      width={200}
                      height={200}
                      alt="Default logo" />
                  )}
                </a> */}
                <div className="login-content">
                  <h2 className="h4 fw-bold">Welcome Back </h2>
                  <p className="">Sign in to your account to continue</p>
                  <form action="#">
                    <div className="d-flex flex-column gap-4">
                      <>
                        <div>
                          <label className="h6  text-opacity-75 mb-3">
                            User Name
                          </label>
                          <input
                            type="text"
                            className="form-control bg-transparent border border-1 colorchange border-white border-opacity-25  py-2 rounded-3"
                            placeholder="Enter User Name"
                            value={userName}
                            onChange={(e) => setUserName(e.target.value)}
                          />
                        </div>
                        {/* <div>
                          <label className="h6  text-opacity-75 mb-3">
                            Mobile Number
                          </label>
                          <input
                            type="text"
                            className="form-control bg-transparent border border-1 colorchange border-white border-opacity-25  py-2 rounded-3"
                            placeholder="Enter Mobile Number"
                            value={mobileNumber}
                            maxLength={10}
                            onChange={(e) => setMobileNumber(e.target.value)}
                          />
                        </div> */}
                        <div className="position-relative">
                          <label className="h6 text-opacity-75 mb-3">Password</label>
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control bg-transparent border border-1 colorchange border-white border-opacity-25 py-2 rounded-3"
                            placeholder="Enter Password"
                            value={password}
                            // maxLength={8}
                            onChange={(e) => setPassword(e.target.value)}
                          />
                          <span
                            className="position-absolute eyess end-0 translate-middle-y pe-3"
                            style={{ cursor: "pointer" }}
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                          </span>
                        </div>

                      </>

                      {/* {isOtpSent && (
                        <div>
                          <label className="h6  text-opacity-75 mb-3 d-flex align-items-center justify-content-between">
                            OTP{" "}

                          </label>
                          <input
                            type="text"
                            className="form-control bg-transparent border border-1 colorchange border-white border-opacity-25  py-2 rounded-3"
                            placeholder="Enter OTP"
                            value={otp}
                            maxLength={6}
                            onChange={(e) => setOtp(e.target.value)}
                          />
                        </div>
                      )} */}
                      <div className="d-flex justify-content-between">
                        <div className="d-flex gap-2 align-items-center">
                          <input id="checkbox" type="checkbox" checked />
                          <label
                            htmlFor="checkbox"
                            className=" text-opacity-75 fs-14"
                          >
                            Remember Me
                          </label>
                        </div>
                        {/* <Link to="/forget-password" className="text-decoration-none text-center d-block mt-2">
                          <div>
                            <p>Forget Password</p></div>
                        </Link> */}
                      </div>
                    </div>


                    <button className="btn px-6 bg-gradient-1 rounded-3 border-0 mt-2 w-100" onClick={handleLogin} disabled={loading}>
                      {loading ? "Logging in..." : "Login"}
                    </button>

{/* 
                    <Link to="/register" className="text-decoration-none text-center d-block mt-2">
                      <button className="btn px-6 bg-gradient-1 rounded-3 border-0 mt-2 w-100"
                        disabled={loading}

                      >
                        Register
                      </button>
                    </Link> */}
                  </form>
                  {/* <p className=" mt-2 text-center">
                    Don’t have an account?{" "}
                    <a href="signup.html" className="linkbuttonlogin">
                      Sign up for free!
                    </a>
                  </p> */}
                </div>

                {/* <div className="pwabutton d-flex justify-content-center">
                  <button>Download App</button>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <div className="admin-login-container">
        <h2 className="text-dark">Admin Login</h2>
        <div className="error-message">{error && <span>{error}</span>}</div>


        {!isOtpSent && (
          <div className="input-group">
            <input
              type="text"
              placeholder="Enter Mobile Number"
              value={mobileNumber}
              onChange={(e) => setMobileNumber(e.target.value)}
            />
          </div>
        )}


        {isOtpSent && (
          <div className="input-group">
            <input
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
          </div>
        )}

        <button
          onClick={isOtpSent ? handleVerifyOtp : handleSendOtp}
          disabled={loading}
        >
          {loading ? (isOtpSent ? "Verifying OTP..." : "Sending OTP...") : (isOtpSent ? "Verify OTP" : "Send OTP")}
        </button>
      </div> */}
    </>
  );
}

export default Login;
